<template>
  <div class="main" id="main">
    <div class="headerBox">
      <van-nav-bar class="title" title="速得尔网上直播">
        <template #right>
          <van-icon
            name="replay"
            size="18"
            color="#fff"
            @click="refreshMatchList()"
          />
        </template>
      </van-nav-bar>
    </div>
    <div class="matchList">
      <van-collapse v-model="activeNames">
        <van-collapse-item
          :title="itemYear"
          :name="itemYear"
          v-for="itemYear in arrMatchYear()"
          :key="itemYear"
        >
          <template #title>
            <div class="yearItem">{{ itemYear }}</div>
          </template>
          <van-list>
            <van-cell
              v-for="item in getMatchList(itemYear)"
              :key="item"
              :title="item"
              @click="changeMatchFun(item)"
            >
              <div class="matchName">
                <div class="borderBox van-hairline--bottom">
                  <span>{{ item.matchName }}</span>
                  <van-icon class="icon" name="arrow" />
                </div>
              </div>
            </van-cell>
          </van-list>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, toRefs } from "vue";
import Paho from "../../common/js/mqtt.js";
import { useRouter } from "vue-router";
import { createState } from "../../store";
var opt;
export default {
  setup() {
    const data = reactive(createState);
    const router = useRouter();
    function goFun(url, topicData) {
      router.push({
        path: url,
        query: topicData,
      });
    }
    return {
      state: reactive(createState),
      Paho: Paho,
      goFun,
      client: ref({}),
      menuList: ref(data.menuList),
      activeNames: ref([]),
      firstshowYear: ref(true),
    };
  },
  methods: {
    // 手动刷新比赛列表
    refreshMatchList() {
      console.log("手动刷新比赛列表");
      if (window.loadMatchData) {
        window.loadMatchData();
      } else {
        console.error("HTTP 轮询组件未初始化");
      }
    },
    //选择年份
    changecollapseFun(event, item) {
      debugger;
      console.log(event);
      console.log(this.activeNames);
      // this.activeNames = [event[event.length-1]]
    },
    //选择比赛
    changeMatchFun(data) {
      console.log(data);
      //将请求的topic赋值到公共参数中
      this.state.selectedMatchId = data.matchId;
      this.state.matchName = data.matchName;

      // 使用新接口加载该比赛的项目数据
      if (window.loadMatchProjects) {
        window.loadMatchProjects(data.matchId);
      }

      // 等待数据加载完成后跳转（数据更新后 reactive 会自动更新视图）
      setTimeout(() => {
        this.state.groupList.value = this.arrMatchGroup();
        this.state.projectList.value = this.arrMatchProject(
          this.state.groupList.value[0],
        );
        this.state.active = this.arrMatchGroup()[0];
        console.log(this.state);
        // this.getfileFun()
        const topicData = {
          selectedMatchId: data.matchId,
        };
        this.goFun("/project", topicData);
      }, 500);
    },
    //获取pdf

    getfileFun() {
      // console.log(this.state.selectedMatchId)
      const data = {
        matchId: this.state.selectedMatchId,
      };
      this.$http
        .get(
          "/File/GetMatchFiles?matchId=" + this.state.selectedMatchId,
          data,
          {
            headers: {
              "Content-Type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          },
        )
        .then((res) => {
          console.log(res);
          if (res.status == 200 && res.data.Code == 0) {
            this.state.pdfmatchList = res.data.Result[0].MatchFileList;
            this.state.pdfprojectList = res.data.Result[0].ProjectFileList;
            this.state.pdfmatchList.map((item) => {
              if (item.FileType == 100) {
                //比赛秩序单
                item.name = "比赛秩序单";
              } else if (item.FileType == 101) {
                //比赛成绩册
                item.name = "比赛成绩册";
              }
            });
            this.state.pdfprojectList.map((item) => {
              if (item.FileType == 200) {
                //项目秩序单
                item.name = "项目秩序单";
              } else if (item.FileType == 2001) {
                //比赛成绩册
                item.name = " 项目成绩单";
              }
            });
          } else if (res.status == 200 && res.data.Code == 204) {
            console.log("无数据");
            this.state.pdfmatchList = [];
            this.state.pdfprojectList = [];
          }
          const topicData = {
            selectedMatchId: data.matchId,
          };
          console.log(this.state);
          this.goFun("/project", topicData);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    onChange() {
      console.log("点击了轮播图");
    },
    //处理数据
    handleFun(data) {
      this.menuList.value = data.menuList;
      this.menuList.value = this.getMatchList();
      console.log(this.menuList);
    },
    mqttFun() {
      this.client = new Paho.MQTT.Client(
        this.state.brokerip,
        8083,
        "WX_Login" + new Date().getTime(),
      );
      var _client = this.client;
      var _this = this;
      opt = this.options = {
        timeout: 5,
        keepAliveInterval: 50,
        reconnect: true, // Enable automatic reconnect
        cleanSession: false,
        useSSL: false,
        userName: "",
        password: "",
        onSuccess: function (responseObject) {
          console.log("连接成功");
          _this.topicFun();
        },
        onFailure: function (e) {
          setTimeout(function () {
            _client.connect(opt);
          }, 5000);
        },
      };
      this.client.connect(opt); //连接服务器并注册连接成功处理事件
      this.client.onConnectionLost = this.onConnectionLost; //注册连接断开处理事件
      this.client.onMessageArrived = this.onMessageArrived; //注册消息接收处理事件
    },
    topicFun() {
      const MQTT_TOPIC = this.state.matchTopic;
      this.client.subscribe(MQTT_TOPIC); //订阅监控通用指令
    },
    onConnectionLost: function (responseObject) {
      console.log(responseObject);
      if (responseObject.errorCode !== 0) {
        console.log("onConnectionLost:" + responseObject.errorMessage);
        this.connected = false;
        console.log("连接已断开");
        console.log(this.client.isConnected());
      }
    },
    onMessageArrived: function (message) {
      // this.payloadFun(message)
      // console.log(
      //   "收到paho消息:" + message.topic + "/n" + message.payloadString
      // );
      try {
        const list = JSON.parse(message.payloadString);
        console.log(list);
        this.handleFun(list);
      } catch (error) {
        console.log(error);
      }
    },
    // 处理select筛选后的数组
    selectedLiveMenu() {
      return this.state.matchList.value.menuList.filter((match) => {
        return match.matchId == this.state.selectedMatchId;
      });
    },
    // 2根据组别筛选比赛
    filterliveMenuByGroup(group) {
      return this.selectedLiveMenu().filter((item) => {
        return item.matchGroupName == group;
      });
    },
    // 3根据组别和项目筛选项目类别
    filterliveMenuByPrjoect(group, project) {
      return this.filterliveMenuByGroup(group)
        .filter((item) => {
          return item.projectName == project;
        })
        .sort((a, b) => {
          return new Date(a.startTime) - new Date(b.startTime);
        });
    },
    // 获取所有年份（使用新接口返回的 matchesList）
    arrMatchYear() {
      if (!this.state.matchesList || this.state.matchesList.length === 0) {
        return [];
      }
      let arr = [];
      this.state.matchesList.forEach((item) => {
        if (arr.indexOf(item.matchYear) == -1) {
          arr.push(item.matchYear);
        }
      });
      if (this.activeNames.length == 0 && this.firstshowYear) {
        this.activeNames = [arr.sort().reverse()[0]];
        this.firstshowYear = false;
      }
      return arr.sort().reverse();
    },
    // 获取所有组别
    arrMatchGroup() {
      let arr = [];
      this.selectedLiveMenu().forEach((item) => {
        if (arr.indexOf(item.matchGroupName) == -1) {
          arr.push(item.matchGroupName);
        } else {
          return false;
        }
      });
      return arr;
    },
    // 获取所有项目
    arrMatchProject(title) {
      let arr = [];
      this.filterliveMenuByGroup(title).forEach((item) => {
        let add = true;
        arr.forEach((arrItem) => {
          if (arrItem[0] == item.projectName) {
            add = false;
            return false;
          } else {
            return false;
          }
        });
        if (add) {
          arr.push([item.projectName, item.topic]);
        }
      });
      return arr;
    },
    // 根据年份获取比赛列表（使用新接口返回的 matchesList）
    getMatchList(year) {
      // 新接口返回的数据已去重，直接按年份过滤
      if (!this.state.matchesList) return [];

      return this.state.matchesList.filter((item) => {
        return item.matchYear == year;
      });
    },
  },
  mounted() {
    // 确保清空 projectTopic
    this.state.projectTopic = "";
  },
  // 组件卸载前清空 projectTopic
  beforeUnmount() {
    console.log("首页卸载，清空 projectTopic");
    this.state.projectTopic = "";
  },
  created() {},
  computed: {},
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  background: linear-gradient(170deg, #adff2f, #4fc5f3, #1f95d3);
}
.yearItem {
  font-size: 0.4rem;
  font-weight: 700;
  color: #fff;
}
/deep/.van-icon {
  color: #fff;
}
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.headerBox {
  width: 100%;
  height: 1rem;
  position: fixed;
  background: #fff;
  z-index: 2;
  .title {
    background: #39a9ed;
    height: 1rem;
    width: 100%;
    display: block;
    /deep/.van-ellipsis {
      color: #fff;
      max-width: 80%;
      font-size: 0.4rem;
    }
  }
}
.my-swipe .van-swipe-item {
  height: 4rem;
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
  img {
    width: 100%;
    height: 4rem;
  }
}
.matchList {
  flex: 1;
  margin-top: 1rem;
  height: auto;
  width: 100%;
  background: #fff;
  .van-list {
    width: 100%;
    height: 100%;
    .matchName {
      font-weight: 600;
      width: 100%;
      min-height: 1rem;
      text-align: left;
      font-size: 0.32rem;
      .borderBox {
        width: 94%;
        min-height: 0.8rem;
        margin: 0.05rem 3%;
        padding: 0.12rem 0.3rem 0.12rem 0;
        border-bottom: 2px solid rgba(255, 255, 255, 0.4);
        display: flex;
        align-items: center;
        transition: all 0.2s ease;
        &:hover {
          background: rgba(255, 255, 255, 0.12);
        }
        &:active {
          transform: scale(0.98);
        }
      }
      span {
        flex: 1;
        height: auto;
        box-sizing: border-box;
        word-break: break-word;
        white-space: normal;
        line-height: 0.48rem;
        color: var(--van-collapse-item-content-text-color);
      }
      .icon {
        width: 0.28rem;
        height: 0.48rem;
        line-height: 0.48rem;
        color: var(--van-collapse-item-content-text-color);
        flex-shrink: 0;
      }
    }
  }
}
</style>
